import { Directive, ElementRef, HostListener, inject, Input } from '@angular/core';

/**
 * Highlight directive
 * Usage: <div appHighlight backgroundColor="yellow">Highlighted text</div>
 */
@Directive({
  selector: '[ktAppHighlight]',
  standalone: true
})
export class HighlightDirective {
  @Input() highlightColor = 'yellow';
  @Input() highlightBackgroundColor = 'yellow';

  el = inject(ElementRef);

  @HostListener('mouseenter')
  onMouseEnter(): void {
    this.highlight(this.highlightBackgroundColor);
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.highlight('transparent');
  }

  private highlight(color: string): void {
    this.el.nativeElement.style.backgroundColor = color;
  }
}
